var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.listClick}},[_c('div',{staticClass:"edit_list"},[_c('span',[_vm._v(_vm._s(_vm.left))]),_c('span',[_vm._t("right")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }